import { Base, Caption, Lead } from '@sbab-ui/components'

interface Props {
  wantedLoanAmount: number
  threeMonthInterestRate: number
  priceMatrixDifference: number
  kilowattLoanDifference: number
  effectiveInterest: number
  blur: boolean
}

export default function TableSection({
  wantedLoanAmount,
  threeMonthInterestRate,
  priceMatrixDifference,
  kilowattLoanDifference,
  effectiveInterest,
  blur,
}: Readonly<Props>) {
  const userRateKilowatt = threeMonthInterestRate + priceMatrixDifference + kilowattLoanDifference
  const userRate = threeMonthInterestRate + priceMatrixDifference
  return (
    <div className={`flex flex-col gap-4 ${blur ? 'text-neutral-95 opacity-50' : 'text-black'}`}>
      <table className="w-full">
        <tbody>
          <TableRow
            label="Ditt önskade lånebelopp"
            value={`${wantedLoanAmount.toLocaleString('sv-SE')} kr`}
            blur={blur}
            lead
          />
          <TableRow
            label="Din ränta Kilowattlånet"
            value={`${userRateKilowatt.toFixed(2).replace('.', ',')} %*`}
            blur={blur}
          />
          <TableRow
            label="Din ränta SBAB bolån"
            value={`${userRate.toFixed(2).replace('.', ',')} %*`}
            blur={blur}
          />
          <TableRow
            label="Effektiv ränta SBAB bolån"
            value={`${effectiveInterest.toFixed(2).replace('.', ',')} %`}
            blur={blur}
          />
        </tbody>
      </table>
      <Caption className={`!mt-0 ${blur ? 'text-neutral-95 opacity-50' : 'text-neutral-40'}`}>
        * Räntan baseras på dagens aktuella 3-månaders ränta.{' '}
      </Caption>
      <Caption className="!mt-0">
        Amortering tillkommer och är inte medräknat i kostnaden som presenteras, vi kommer att prata
        mer om det när ansökan är inskickad. Räntan sätts på utbetalningsdagen och du kan då välja
        den bindningstid som passar er.
      </Caption>
    </div>
  )
}

interface TableRowProps {
  label: string
  value: string
  blur: boolean
  lead?: boolean
}

function TableRow({ label, value, blur, lead = false }: Readonly<TableRowProps>) {
  function getBorderBottomStyle(blur: boolean, lead: boolean) {
    let color = lead ? '#1A1A1A' : '#999999'
    if (blur) {
      color = '#F2F2F2'
    }
    return `1px solid ${color}`
  }
  const borderBottomStyle = getBorderBottomStyle(blur, lead)
  return (
    <tr
      className="flex h-10 items-center justify-between"
      style={{ borderBottom: borderBottomStyle }}
    >
      {lead ? (
        <>
          <td>
            <Lead className="!mt-0">{label}</Lead>
          </td>
          <td>
            <Lead className="!mt-0">{value}</Lead>
          </td>
        </>
      ) : (
        <>
          <td>
            <Base className="!mt-0">{label}</Base>
          </td>
          <td>
            <Base className="!mt-0">{value}</Base>
          </td>
        </>
      )}
    </tr>
  )
}
